import * as Icons from "heroicons-react";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Toaster } from "react-hot-toast";
// import Resizer from "react-image-file-resizer";
import { useSelector } from "react-redux";
import logo from "../../../logo.svg";
import {
  useAddSettingsMutation,
  useSettingsQuery,
} from "../../../services/settingsApi";
import { JwtReValidate, signInUser } from "../../Utility/Auth";
import { notify } from "../../Utility/Notify";
import { IoSave } from "react-icons/io5";

const LayoutSettings = () => {
  const user = signInUser();
  const { aamarId } = user;
  const lang = useSelector((state) => state.languageReducer);
  const { data: settings, isSuccess, refetch } = useSettingsQuery(aamarId);
  const [addSettings] = useAddSettingsMutation();
  const [isEcommerceToggled, setIsEcommerceToggled] = useState(false);
  const [selectedImage, setSelectedImage] = useState("image1");

  const { register, handleSubmit } = useForm();

  // Handle form submission
  const onSubmit = async (data, message) => {
    const payload = {
      ...data,
      aamarId: aamarId,
    };
    // console.log("Payload for submission:", data);
    const response = await addSettings(payload);
    // console.log("Response", response);
    if (response?.data) {
      await JwtReValidate();

      refetch();
      notify(message, "success");
    } else {
      notify("Failed to add settings.", "error");
    }
  };

  return (
    <div style={{ marginTop: "80px" }}>
      <form
        onSubmit={handleSubmit((data) =>
          onSubmit(data, "General Layout Settings saved successfully!")
        )}
      >
        <div className="mb-4">
          <h5 className="mb-3 d-flex align-items-center gap-2 mt-5">
            Layout Settings
          </h5>
          <hr />

          {/* Site Width */}
          <div className="d-flex justify-content-between mb-4">
            <span className="d-flex align-content-center gap-2">
              Site Width
            </span>
            <div className="image-selection d-flex gap-3">
              {[
                { key: "boxed", label: "Boxed" },
                { key: "fullwidth", label: "Full Width" },
              ].map((item, index) => (
                <div
                  key={index}
                  onClick={() =>
                    !isEcommerceToggled && setSelectedImage(item.key)
                  }
                  className={`theme-option text-center ${
                    selectedImage === item.key ? "selected" : ""
                  }`}
                  style={{
                    border:
                      selectedImage === item.key
                        ? "1px solid #F2652D"
                        : "1px solid #ccc",
                    padding: "5px",
                    cursor: isEcommerceToggled ? "not-allowed" : "pointer",
                    borderRadius: "8px",
                    opacity: isEcommerceToggled ? 0.5 : 1,
                  }}
                >
                  <img
                    src={logo}
                    alt={item.label}
                    className="theme-image mb-2"
                    style={{ width: "280px", height: "250px" }}
                  />
                  <div style={{ fontSize: "14px", color: "#333" }}>
                    {item.label}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Sidebar Settings */}
          <div className="mb-3 mt-3">
            <label>Sidebar Settings</label>
            <div className="d-flex justify-content-between mt-2 flex-wrap gap-3">
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  {...register("sidebar.search")}
                />
                <label className="form-check-label ms-2">Search</label>
              </div>
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  {...register("sidebar.categories")}
                />
                <label className="form-check-label ms-2">Categories</label>
              </div>
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  {...register("sidebar.brands")}
                />
                <label className="form-check-label ms-2">Brands</label>
              </div>
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  {...register("sidebar.priceRange")}
                />
                <label className="form-check-label ms-2">Price Range</label>
              </div>
            </div>
          </div>

          {/* Sticky Sidebar Toggle */}
          <div className="mb-3 mt-4">
            <label>Sticky Sidebar</label>
            <div className="form-check form-switch mt-2">
              <input
                className="form-check-input"
                type="checkbox"
                role="switch"
                {...register("stickySidebar")}
              />
              <label className="form-check-label ms-2">
                Enable Sticky Sidebar
              </label>
            </div>
          </div>

          {/* Submit Button */}
          <div className="d-flex justify-content-end mt-4">
            <button
              type="submit"
              className="btn btn-dark d-flex justify-content-center align-items-center gap-2"
            >
              <IoSave size={16} className="me-1" />
              <span>Save</span>
            </button>
          </div>
        </div>
      </form>
      <Toaster position="bottom-right" />
    </div>
  );
};

export default LayoutSettings;
